import Image from 'app/Components/Shared/Image/image';
import React, { useCallback } from 'react';
import EpiContext from '@episerver/spa-core/Spa';
import gaParams from 'app/utilities/analytics/constants';
import {gaEvent} from 'app/utilities/analytics/tracking';
import {navigateTo} from 'app/utilities/StringHelpers/StringHelpers';

const PortalItem = ({portal}) => {

  const reportGA = (portalName) => {
    gaEvent(gaParams.BUSINESS_PORTAL_CLICK_ON_PORTAL.category, gaParams.BUSINESS_PORTAL_CLICK_ON_PORTAL.eventType, portalName);
  };

  const handleClick = () => {
    if (portal?.link) {
      reportGA(portal?.title);
      navigateTo(portal.link);
    }
  };

  return (
    <div className='business-dashboard-portal-item'>
      <span className='portal-title'>{portal?.title}</span>
      <div
        className='icon-text-container'
        onClick={handleClick}>
        <span className='portal-link-text'>{portal?.linkText}</span>
        <Image src={portal?.icon} className='portal-icon' />
      </div>
    </div>
  );
};

export default PortalItem;
